<template>
    <div :class="$style.end">
        <Button
            interfaceTarget="random-game"
            size="l"
            color="purple-graphite"
            :target="props.targetUrl"
            :to="{ name: ROUTE_NAMES.RANDOM_GAME }"
            :class="$style.random_game_button_override"
        >
            {{ $tr('theEnd.random_game') }}
        </Button>
        <Button
            interfaceTarget="scroll-to-top"
            size="l"
            color="purple-graphite"
            icon="scroll-to-top"
            :class="$style.scroll_to_top_button_override"
            @click="scrollToTop"
        />
    </div>
</template>

<script setup lang="ts">
import Button from '@/components_new/Button.vue'
import { ROUTE_NAMES } from '@/router/constants'

const props = defineProps<{
    targetUrl?: '_blank'
}>()

function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style module>
.end {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.random_game_button_override {
    height: 56px;
    padding: 0 48px;
}

.scroll_to_top_button_override {
    width: 56px;
    height: 56px;
}
</style>
